import { useQueryClient } from '@tanstack/react-query'

import type { TemplateListItem } from '#/shared/api/generated/communication/models'
import { getGetTemplateApiV1TemplatesTemplateIdGetQueryOptions } from '#/shared/api/generated/communication/theCargoCommunication'

export function useLoadTemplate() {
  const queryClient = useQueryClient()
  return async (templateId: string): Promise<TemplateListItem> => {
    const response = await queryClient.fetchQuery(
      getGetTemplateApiV1TemplatesTemplateIdGetQueryOptions(templateId),
    )
    return response.data
  }
}
